import { render } from "./MultipleSelectionPopUp.vue?vue&type=template&id=632710ae&scoped=true&ts=true"
import script from "./MultipleSelectionPopUp.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectionPopUp.vue?vue&type=script&lang=ts"

import "./MultipleSelectionPopUp.vue?vue&type=style&index=0&id=632710ae&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632710ae"]])

export default __exports__